export default "__VITE_ASSET__47e55c9c__"